export enum BannerEvent {
    NON_OWNED_FILE = "NON_OWNED_FILE",
    FOLDER_WITH_NON_OWNED_FILES = "FOLDER_WITH_NON_OWNED_FILES",
    NON_CONTROLLED_CLASS = "NON_CONTROLLED_CLASS",
    OUTSIDE_CLASS = "OUTSIDE_CLASS",
    ADMIN_EMAIL_DOMAIN_NOT_WELL_SPELLED = "ADMIN_EMAIL_DOMAIN_NOT_WELL_SPELLED",
    ADMIN_SHCOOL_NOT_IN_LIST = "ADMIN_SHCOOL_NOT_IN_LIST",
    STUDY_LOCK_ALL_SETTINGS = "STUDY_LOCK_SETTINGS",
    STUDY_UNLOCK_ALL_SETTINGS = "STUDY_UNLOCK_SETTINGS",
    STUDY_LOCK_SETTINGS_SECTION = "STUDY_LOCK_SETTINGS_SECTION",
    STUDY_UNLCOK_SETTINGS_SECTION = "STUDY_UNLOCK_SETTINGS_SECTION",
    FLASHCARDSET_DISABLED_OPTIONS = "FLASHCARDSET_DISABLED_OPTIONS",
    CONFIGURED_SETTINGS = "CONFIGURED_SETTINGS",
    SCHOOLS_PILOT = "SCHOOLS_PILOT",
    JOIN_PILOT = "JOIN_PILOT",
    SWITCH_CONTRACT = "SWITCH_CONTRACT",
}

type EventDetails = {
    [key in BannerEvent]: {
        label: string;
        instruction?: string;
    };
};

export const EVENT_Details: EventDetails = {
    [BannerEvent.NON_OWNED_FILE]: {
        label: "Sorry, you don’t have the right role in this class to add files here.",
    },
    [BannerEvent.FOLDER_WITH_NON_OWNED_FILES]: {
        label: "Other peoples files are in this folder. Do you want to continue?",
    },
    [BannerEvent.NON_CONTROLLED_CLASS]: {
        label: "Sorry, you don't have access to this class.",
    },
    [BannerEvent.OUTSIDE_CLASS]: {
        label: "You can't move others files outside the class",
    },
    [BannerEvent.ADMIN_EMAIL_DOMAIN_NOT_WELL_SPELLED]: {
        label: "Please double check that the email domain is spelled correctly and is for your district only. Please call 848-391-0575 if you have questions.",
    },
    [BannerEvent.ADMIN_SHCOOL_NOT_IN_LIST]: {
        label: "Don’t see your school in our list?",
        instruction: "Make sure you have the right zip code, and if you still don’t see it please press add.",
    },
    [BannerEvent.STUDY_LOCK_ALL_SETTINGS]: {
        label: "Lock all options so your students can’t change them, or set the locks individually below and press save!",
    },
    [BannerEvent.STUDY_UNLOCK_ALL_SETTINGS]: {
        label: "Unlock all options so your students can change them, or set the locks individually below and press save!",
    },
    [BannerEvent.STUDY_LOCK_SETTINGS_SECTION]: {
        label: "Lock the options in this section so your students can’t change them",
    },
    [BannerEvent.STUDY_UNLCOK_SETTINGS_SECTION]: {
        label: "Unlock the options in this section so your students can change them",
    },
    [BannerEvent.FLASHCARDSET_DISABLED_OPTIONS]: {
        label: "Certain options have been disabled. Please contact your teacher if you need access to these modes.",
    },
    [BannerEvent.CONFIGURED_SETTINGS]: {
        label: "Some settings have been configured by your teacher.",
    },
    [BannerEvent.SCHOOLS_PILOT]: {
        label: "All schools can start a FREE 6 month pilot (until July 2025). No payment required!",
    },
    [BannerEvent.JOIN_PILOT]: {
        label: "Start a pilot until the end of the school year for unlimited licenses for free!",
    },
    [BannerEvent.SWITCH_CONTRACT]: {
        label: "Switch your contract to Knowt for 1 year free!",
    },
};
